/**
 * @generated SignedSource<<4dd569e720cde7317696c7ea2b7cb98a>>
 * @relayHash 850ebfae14461f590dab32639d9975d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b46dcd216ada596b921f01749512ffaf9b266577b416b15e42b00ca2e3187836

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type WhiteboardExtensionCreateWhiteboardMutation$variables = {
  createdInContentId: string;
  spaceKey?: string | null | undefined;
};
export type WhiteboardExtensionCreateWhiteboardMutation$data = {
  readonly createContentInline: {
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type WhiteboardExtensionCreateWhiteboardMutation = {
  response: WhiteboardExtensionCreateWhiteboardMutation$data;
  variables: WhiteboardExtensionCreateWhiteboardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "createdInContentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "createdInContentId",
            "variableName": "createdInContentId"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          },
          {
            "kind": "Literal",
            "name": "type",
            "value": "whiteboard"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "createContentInline",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WhiteboardExtensionCreateWhiteboardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WhiteboardExtensionCreateWhiteboardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "850ebfae14461f590dab32639d9975d2",
    "id": "b46dcd216ada596b921f01749512ffaf9b266577b416b15e42b00ca2e3187836",
    "metadata": {},
    "name": "WhiteboardExtensionCreateWhiteboardMutation",
    "operationKind": "mutation",
    "text": "mutation WhiteboardExtensionCreateWhiteboardMutation($createdInContentId:ID!,$spaceKey:String){createContentInline(input:{createdInContentId:$createdInContentId,spaceKey:$spaceKey,type:\"whiteboard\"}){id}}"
  }
};
})();

(node as any).hash = "3d1403ce2fe2c2c31def65ef0ccedba0";

export default node;
